import { Outlet } from "react-router";
import SelskabsblankettenProvider from "./providers/AppProvider";
import "./styles/selskabsblanketten.scss";

export default function SelskabsblankettenApp() {
  return (
    <SelskabsblankettenProvider>
      <div className="bg-body flex-grow-1">
        <Outlet />
      </div>
    </SelskabsblankettenProvider>
  );
}
